import request from '@/utils/request'

// 获取员工业绩列表
export function employeePerformanceGetList(data) {
  return request({
    url: '/admin/Employee_performance/getList',
    method: 'post',
    params: data
  })
}

// 导出员工业绩
export function employeePerformanceExport(data) {
  return request({
    url: '/admin/Employee_performance/export',
    method: 'get',
    params: data,
    responseType: 'blob'
  })
}

// 批量获取门店店长
export function getShopManagers(shopIds) {
  return request({
    url: '/erp/report/shop-managers',
    method: 'get',
    params: { shop_ids: shopIds.join(',') }
  })
}



// WEBPACK FOOTER //
// ./src/api/employeePerformance.js